import { tariffLongNameMapping, tariffNameMapping } from '../models/tariff';
var MAXIMUM_SICKDAY_PAYOUT = 130;
export var roundToTwoDecimal = function (input) { return +input.toFixed(2); };
export var getAgeFromBirthYear = function (birthYear) {
    return new Date().getFullYear() - birthYear;
};
export var isOver50 = function (birthYear) {
    return getAgeFromBirthYear(birthYear) > 50;
};
export var getTariffLabel = function (tariff, longName) {
    return longName ? tariffLongNameMapping[tariff] : tariffNameMapping[tariff];
};
/**
 * @description Calculates the sickday payout amount based on a monthly payout of around 70% of income
 *
 * NOTE: Provider only accepts daily sickday payout amounts that are multiples of €5
 *
 * @return The default sick pay coverage, rounded to the nearest €5, max €130
 *
 */
export var getDefaultSickDayPayout = function (income) {
    return Math.min(Math.floor((income * 0.7) / 12 / 30 / 5) * 5, MAXIMUM_SICKDAY_PAYOUT);
};
